module.exports = __webpack_public_path__ + "static/media/Icon.198e6536.png";